module.exports = __webpack_public_path__ + "static/img/nasa_rocket_simulation.4294558.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nasa_rocket_simulation.jpg
// module id = zEhN
// module chunks = 0